<template>
  <div class="w-100">

    <!--  UI layout for pie chart  -->
    <b-container 
      fluid 
      ref="chartContainer" 
      class="chart-container__main"
      v-if="this.isPieChartVisible()"
    >

      <b-row class="chart-pie__height d-flex justify-content-center mt-lg-3">
        <accentuated-slice-pie 
          class="align-self-end align-self-center"
          v-if="this.isPieChartVisible()"
          :values="[{'sliceColor': this.baseColor, 'sliceLabel': this.sliceLabel,  'slicePercentage': this.slicePercentage}]"
          :width="this.getPieHeight()"
        >
        </accentuated-slice-pie>
      </b-row>

      <b-row class="mt-5">
        <div class="text-item">
          <span v-html="$t(item.text, this.getIntermediateResultMetaInformation())"/>
        </div>
      </b-row>
    </b-container>

    <!--  UI layout for avatar chart  -->
    <b-container 
      fluid 
      ref="chartContainer"
      class="chart-container__main"
      v-if="this.isAvatarChartVisible()"
    >

      <b-row class="vh-10">
      </b-row>

      <b-row class="chart-avatar__height d-flex justify-content-center px-md-5">
        <avatar-chart 
          class="align-self-end"
          v-if="this.isAvatarChartVisible()"
          :accentuated-avatar-index="this.selectedAvatarIndex"
          :label-min="this.$t(`${this.item.text}_MIN`)"
          :label-max="this.$t(`${this.item.text}_MAX`)"
          :label-avatar="this.$t(`${this.item.text}_AVATAR_IDENTIFIER`)"
        ></avatar-chart>
      </b-row>
      <b-row class="mt-5">
        <div class="text-item">
          <span v-html="$t(item.text, this.getIntermediateResultMetaInformation())"/>
        </div>
      </b-row>
    </b-container>

  </div>
</template>

<script>

  import question from '@/components/ui/question'
  import accentuatedSlicePie from '@/components/ui/accentuatedSlicePie'
  import avatarChart from '@/components/ui/avatarChart'
  import { formatNumber } from '@/utils/numbers'
  import colorVariantMixin from "@/components/mixins/colorVariantMixin";

  export default {
    name: 'intermediateResultItem',
    components: {
      question,
      'accentuated-slice-pie': accentuatedSlicePie,
      'avatar-chart': avatarChart
    },
    mixins: [colorVariantMixin],
    props: {
      item: {
        type: Object,
      },
      metaData: {
        type: Object
      },
      itemProperties: {
        type: Object
      },
      locale: {
        type: Object
      }
    },
    watch: {
      metaData: function (val) {
        this.initializeComponent(val.metaInformation)
      }
    },
    data() {
      return {
        slicePercentage: 0,
        sliceLabel: "0%",
        selectedAvatarIndex: 0,
        conditionText: '',
      };
    },
    mounted() {
      // text item immediately emits result
      this.$emit('answer', { result: 1 })
    },
    methods: {
      initializeComponent(metaInformation) {
        if (this.isInvestmentGoalsType()) {
          this.slicePercentage = parseInt(metaInformation['CHOICE_DISTRIBUTION'], 10);
          this.sliceLabel = `${formatNumber(this.slicePercentage)}%`;
          if (this.slicePercentage >= 1 ) {
            metaInformation['CHOICE_DISTRIBUTION'] = formatNumber(this.slicePercentage)
          }

          const conditionValueString = this.itemProperties.getProperty('condition_text_value');
          if (conditionValueString) {
            this.conditionText =  this.$t(`${this.item.text}_CONDITION_TEXT_TRUE`);
          }
        }

        if (this.isFinancialSatisfactionType()) {
          metaInformation['AGE_RANGE_DISTRIBUTION'] = formatNumber(parseFloat(metaInformation['CHOICE_DISTRIBUTION']), this.locale.tag, 0, 1)
          this.selectedAvatarIndex = parseInt(metaInformation['INPUT_RESULT'], 10);
        }

        if (this.isDecisionMakingType()) {
          this.slicePercentage = parseInt(metaInformation['LOOKUP_PERCENTILE'], 10);
          if (this.slicePercentage >= 1 ){
            metaInformation['LOOKUP_PERCENTILE'] = formatNumber(this.slicePercentage)
          }
          this.sliceLabel = `${formatNumber(this.slicePercentage)}%`;
        }
      },
      getDisplayType() {
        return this.itemProperties.getProperty('display_type')
      },
      isDecisionMakingType() {
        return "decision_making" === this.getDisplayType()
      },
      isInvestmentGoalsType() {
        return "investment_goals" === this.getDisplayType()
      },
      isFinancialSatisfactionType() {
        return "financial_satisfaction" === this.getDisplayType()
      },
      isPieChartVisible() {
        return this.isDecisionMakingType() || this.isInvestmentGoalsType()
      },
      isAvatarChartVisible() {
        return this.isFinancialSatisfactionType()
      },
      getIntermediateResultMetaInformation() {
        if (this.metaData !== null && this.metaData.metaInformation !== null) {
          this.metaData.metaInformation['DELTA_TEXT'] = this.$t(`${this.item.text}_DELTA_TEXT${this.selectedAvatarIndex}`);
          this.metaData.metaInformation.condition_text = this.conditionText;
          return this.metaData.metaInformation;
        }

        return {};
      },
      getPieHeight() {
        if (this.$refs.chartContainer === undefined) {
          return 100;
        }

        if (this.$refs.chartContainer.clientWidth > 800) {
          return 300;
        }

        return this.$refs.chartContainer.clientWidth / 2.5
      }
    }
  };
</script>
<style lang="scss">
  .text-item {
    height: 100%;
  }

  @media screen and (min-width: 992px) {
    .chart-container__main {
      min-height: 0 !important;
    }

    .chart-pie__height {
      height: 60% !important;
    }

    .chart-avatar__height {
      height: 30vh !important;
    }
  }

  .chart-container__main {
    min-height: 100%;
  }

  .chart-pie__height {
    height: 50vh;
  }

  .chart-avatar__height {
    height: 40vh;
  }

</style>
